const GOOGLE_SHEETS_OAUTH_CONFIG = {
  // Dev app, usable only with @customer.io GSuite accounts.
  development: {
    appId: '437488193900',
    clientId: '437488193900-q8a22ci6dlak0kkk499sf51jferqteqr.apps.googleusercontent.com',
  },
  // Dedicated Google app for production, production-like staging, and standalone.
  production: {
    appId: '469883758034',
    clientId: '469883758034-d2pdph21nh3ggrt4c39j08ltail4o2jo.apps.googleusercontent.com',
  },
} as const;

function getGoogleSheetsOAuthConfig() {
  if (
    __CIO_ENV__ === 'production' ||
    __CIO_ENV__ === 'standalone' ||
    __CIO_ENV__ === 'prod-staging-1' ||
    __CIO_ENV__ === 'prod-staging-2'
  ) {
    return GOOGLE_SHEETS_OAUTH_CONFIG.production;
  }

  return GOOGLE_SHEETS_OAUTH_CONFIG.development;
}

export function getGoogleSheetsClientId(): string {
  return getGoogleSheetsOAuthConfig().clientId;
}

export function getGoogleSheetsAppId(): string {
  return getGoogleSheetsOAuthConfig().appId;
}
